import React from "react";
import { AppRoutes } from "./router/appRoutes";
import "./App.css";

const App = () => {
	return <AppRoutes />;
};

export default App;
